import actionConstants from '../constants/';

const getOffersList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const manageCampaign = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  offersList: { ...getOffersList },
  manageCampaign: { ...manageCampaign },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function paymentReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_OFFERS_LIST_REQUEST:
      return {
        ...state,
        offersList: {
          ...state.offersList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_OFFERS_LIST_SUCCESS:
      return {
        ...state,
        offersList: {
          ...state.offersList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_OFFERS_LIST_FAILURE:
      return {
        ...state,
        offersList: {
          ...state.offersList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_OFFERS_LIST_CLEAR:
      return {
        ...state,
        offersList: {
          ...initialState.offersList,
          data: {},
          isLoading: false,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.MANAGE_CAMPAIGN_REQUEST:
      return {
        ...state,
        manageCampaign: {
          ...state.manageCampaign,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.MANAGE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        manageCampaign: {
          ...state.manageCampaign,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.MANAGE_CAMPAIGN_FAILURE:
      return {
        ...state,
        manageCampaign: {
          ...state.manageCampaign,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.MANAGE_CAMPAIGN_CLEAR:
      return {
        ...state,
        manageCampaign: {
          ...initialState.manageCampaign,
          data: {},
          isLoading: false,
          isSuccess: false,
          isFailure: false,
        },
      };

    default:
      return state;
  }
}
